/**
 * @generated SignedSource<<8107ad183ae1198fac6226bad3d2804a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemFooterPending_todo$data = {
  readonly assigned: ReadonlyArray<{
    readonly __typename: "AssignedEmployee";
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly __typename: "AssignedRole";
  }>;
  readonly commentCount: number;
  readonly contact: {
    readonly __typename: "TodoContact";
  } | null;
  readonly expireAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly linkedProducts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoListItemProducts_StoreProduct">;
  }>;
  readonly subTodos: ReadonlyArray<{
    readonly __typename: "Todo";
  }> | null;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoListItemTags_tag">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemAssignedUsers_todo" | "TodoListItemContact_todo" | "TodoListItemFooterSubTodos_todo">;
  readonly " $fragmentType": "TodoListItemFooterPending_todo";
};
export type TodoListItemFooterPending_todo$key = {
  readonly " $data"?: TodoListItemFooterPending_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooterPending_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemFooterPending_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemAssignedUsers_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemContact_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoListItemTags_tag"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoListItemProducts_StoreProduct"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooterSubTodos_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "7d17645600a93a2e0c553b2e32d60b12";

export default node;
